import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sunrise } from 'lucide-react';
export function Hero() {
  return <section className="relative h-screen w-full overflow-hidden bg-[#F5F1ED]" data-id="element-79">
      {/* Enhanced morning light gradient with multiple layers */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#FFF8F0] via-[#F5F1ED] to-[#E8E3DD]" data-id="element-80" />

      {/* Soft morning sun glow - multiple layers for depth */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 2,
      ease: 'easeOut'
    }} className="absolute top-[-15%] right-[-10%] w-[70vh] h-[70vh] rounded-full bg-gradient-to-b from-[#FFE5B4] via-[#FFD89B] to-transparent blur-3xl opacity-40" data-id="element-81" />
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 2.5,
      ease: 'easeOut',
      delay: 0.3
    }} className="absolute top-[-5%] right-[5%] w-[50vh] h-[50vh] rounded-full bg-gradient-to-b from-[#FFF] to-[#F5F1ED] blur-2xl opacity-60" data-id="element-82" />

      {/* Floating morning mist effect */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 0.15,
      y: 0
    }} transition={{
      duration: 3,
      ease: 'easeOut',
      delay: 0.5
    }} className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-[#E8E3DD]/50 to-transparent" data-id="element-83" />

      {/* Decorative morning elements */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1.5,
      delay: 1
    }} className="absolute top-[20%] left-[10%] w-32 h-32 rounded-full bg-[#D4AF37]/5 blur-xl" data-id="element-84" />
      <motion.div initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1.5,
      delay: 1.2
    }} className="absolute bottom-[30%] right-[15%] w-40 h-40 rounded-full bg-[#FFE5B4]/10 blur-2xl" data-id="element-85" />

      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 flex flex-col justify-center" data-id="element-86">
        <div className="max-w-3xl" data-id="element-87">

          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: [0.22, 1, 0.36, 1]
        }} className="text-5xl md:text-7xl lg:text-8xl font-bold text-[#2D3748] tracking-tight leading-[1.1] mb-8" data-id="element-88">
            Start your day <br data-id="element-89" />
            <span className="text-[#D4AF37] italic font-serif" data-id="element-90">
              beautifully.
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="text-lg md:text-xl text-[#2D3748]/80 max-w-xl leading-relaxed mb-10" data-id="element-91">
            Fresh fare. Thoughtful design. A calm foundation for your team's
            best work.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.8
        }} className="flex flex-wrap gap-4" data-id="element-92">
            <a href="#contact" className="group inline-flex items-center px-8 py-4 rounded-full bg-[#2D3748] text-[#F5F1ED] font-medium transition-all hover:bg-[#1a202c] hover:scale-105 active:scale-95" data-id="element-93">
              Inquire Now
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-94" />
            </a>
            <a href="#services" className="inline-flex items-center px-8 py-4 rounded-full border border-[#2D3748]/20 text-[#2D3748] font-medium hover:bg-[#E8E3DD] transition-colors" data-id="element-95">
              View Menu
            </a>
          </motion.div>
        </div>
      </div>

      {/* Enhanced scroll indicator with morning theme */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2" data-id="element-96">
        <span className="text-xs text-[#2D3748]/40 tracking-wider" data-id="element-97">SCROLL</span>
        <div className="w-[1px] h-16 bg-gradient-to-b from-[#2D3748]/0 via-[#2D3748]/40 to-[#2D3748]/0" data-id="element-98" />
      </motion.div>
    </section>;
}